export const ContextOpts = [
  { label: "System", value: "system" },
  { label: "Entity", value: "entity" },
];
